import { render } from "./ProfileEditComponent.vue?vue&type=template&id=d1e47656"
import script from "./ProfileEditComponent.vue?vue&type=script&lang=js"
export * from "./ProfileEditComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__